import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Minimal subset of the Aura backend's `AgentType` returned by `GET /agents/`. */
export interface AuraAgentType {
  id: string;
  name: string;
  description: string;
  userFacingDescription: string;
}

/**
 * Fetches the available Aura agents from the Aura backend, which is a separate origin
 * from the warehouse API. Auth is attached by `keycloakAuthInterceptor`, which also
 * covers the Aura base URL.
 */
@Injectable({ providedIn: 'root' })
export class AuraAgentsService {
  private readonly httpClient = inject(HttpClient);
  private readonly agentsUrl = `${environment.aura.apiBaseUrl}/agents/`;

  getAvailableAgents(): Observable<AuraAgentType[]> {
    return this.httpClient.get<AuraAgentType[]>(this.agentsUrl);
  }
}
